<template>
    <el-dialog
        :close-on-click-modal="false"
        width="60%"
        append-to-body
        title="试题导入"
        :visible.sync="visible"
        :lock-scroll="false">
        <div v-html="rulesContent" style="font-size: 16px"></div>
       <div style="margin-top: 30px">
           <el-button type="primary" size="medium" @click.stop="exampleVisible = true" icon="el-icon-view">查看输入示例</el-button>
           <el-button type="primary" size="medium"
                      @click.stop="importPaper"
                      icon="el-icon-upload2">导入试题</el-button>
           <a
               :href="$store.state.protocol + '//fmh.cqvip.com/download/52279d041f0a4ea586cd3810ab519d7f.docx'"
               download="试题模板"
               style="text-decoration: none;color:#f00; margin: 0 20px"><i
               class="el-icon-download"
               style="margin:0 5px"></i>下载模板</a>
       </div>
        <el-dialog append-to-body width="900px" :visible.sync="exampleVisible" title="查看输入示例">
            <div style="padding: 0 30px">
                 <pre style="font-size: 16px; font-family: inherit; ">
  1、[单选题]单选题题干XXX
    A、选项1
    B、选项2
    C、选项3
    D、选项4
    答案：D
    解析：解析内容XXXX
    所属分类：自建分类1

 2、[多选题]多选题题干XXX
    A、选项1
    B、选项2
    C、选项3
    D、选项4
    答案：A、C、D
    解析：解析内容XXXX
    所属分类：自建分类1

 3、[判断题]判断题题干XXX
    A、正确
    B、错误
    答案：正确（错误）
    解析：解析内容XXXX
    所属分类：自建分类1

 4、[填空题]填空题题干，填空题空项需要用如(________)所示，既是我国特有的珍贵物种，(________)XXXXX
    空1:XXX答案1; XXXX答案2;
    空2:XXXX
    解析：解析内容XXXX
    所属分类：自建分类1

 5、[问答题]问答题题干XXXX
    答案：答案内容XXXX
    多行答案1
    解析：解析内容XXXX
    解析多行
    所属分类：自建分类1
            </pre>
            </div>
        </el-dialog>
    </el-dialog>
</template>

<script>
import { uploadOfInput } from "@/utils";
import { uploadFile, importQuestionFromWord } from "@/api/manage";
export default {
    name: "word-template",
    data () {
        return {
            visible: false,
            exampleContent:
                "<p style='color:#ff9197' class='font-medium'>单选题</p><p>1、大海是什么颜色的?<p><p>A、绿色</p><p>B、蓝色</p><p>C、红色</p><p>D、粉色</p><p>答案：B</p><p>解析:蓝色</p><p>难度:简单</p><br /><p style='color:#408AF2' class='font-medium'>多选题</p><p>2、请选择正确的夏天应该穿的衣服?<p><p>A、裙子</p><p>B、棉袄</p><p>C、短袖</p><p>D、秋裤</p><p>E、毛衣</p><p>答案:A、C</p><p>解析:请结合生活实际</p><p>难度:简单</p><br /><p style='color:#5ac325' class='font-medium'>填空题<p>3、床前明月光的后三句诗词()、()、()</p>答案:疑似地上霜|举头望明月；低头思故乡</p><p>解析:《静夜思》</p><p>难度:普通</p><br /><p style='color:#a45ae6' class='font-medium'>判断题<p>4、新青年刊登的第一篇白话文是《狂人日记》吗</p><p>答案：正确</p><p>难度：困难</p><p>解析：请查询中国近代史</p><br /><p style='color:#FFBF00' class='font-medium'>简答题<p>5、请简述一下你对当今中国美好未来的期许</p><p>答案：自由发挥</p><p>解析：(选填)</p>",
            rulesContent:
                "<p>1、所有题型标号支持1.或1、两种格式。</p><p>2、所有题型必须含有 “ 答案：”字段，且不能为空。</p><p>3、所有题型 “ 解析：” 字段非必需，没有可不填。</p><p>4、所有题型必须含有 “ 难度：”字段，且不能为空，如若输入题型未设置难度将会设置为默认难度<span class='c-256CF4'>普通</span>。</p><p>5、所有题型支持插入图片(填空题答案不允许为图片)。</p><p>6、选择题最少支持2个选项A,B，最多支持8个选项A,B,C,D,E,F,G,H且按照顺序使用。</p><p>7、选择题A-H这些选项号与内容之间要用、 . ：:(顿号、英文句号、中文或英文分号)四种中任意一种符号分开。</p><p>8、多选题答案请至少输入两个答案，且选项答案请用、.，,(顿号、英文句号、中文或英文逗号)四种中任意一种符号分开。</p><p>9、判断题答案支持 “错误”，“正确” 或者 “错”，“对”。</p><p>10、填空题仅支持题目中出现括号()、（）或_三种符号。</p><p>11、填空题目里的多个填空答案要用 | ；;三种中任意一种符号分开，单个答案不用添加。</p><p>12、填空题的填空数需与答案数一致。</p>",
            exampleVisible: false
        }
    },
    methods: {
        open () {
            this.visible = true
        },
        close () {
            this.visible = false
        },
        // 导入用户
        importPaper () {
            uploadOfInput((file) => {
                if (!file) return
                const loading = this.$loading({
                    lock: true,
                    text: "导入中",
                    background: "rgba(0, 0, 0, .2)"
                });
                uploadFile({ file }).then(res => {
                    importQuestionFromWord(res).then(file => {
                        this.$message.success("导入成功")
                        this.$emit("updateList")
                        loading.close()
                        this.close()
                    }).catch(e => {
                        loading.close()
                    })
                }).catch(e => {
                    loading.close()
                })
            }, () => {
                this.$message.error("选择文件失败")
            }, ".doc,.docx")
        }
    }
}
</script>
